/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {
  jobSearchEngineRerunFailedShowDialogSelector,
  jobSearchEngineRerunSelectedSelector,
  jobSearchEngineRerunShowDialogSelector,
  jobSearchEngineRerunTaskShowDialogSelector
} from '../../../store/selectors/jobsearchengine';

/**
 * React Hook to provide selector/state for Job 2.0 rerun functionality.
 *
 *  ```typescript
 *   import {useJobSearchEngineRerun} from '../../../routes/provisioning/jobsearchengine';
 *
 *   const {
 *     rerunSelected,
 *     rerunShow,
 *     rerunError
 *   } = useJobSearchEngineRerun();
 *  ```
 */
export const useJobSearchEngineRerun = () => {
  const rerunSelected       = useSelector(jobSearchEngineRerunSelectedSelector);
  const rerunShow           = useSelector(jobSearchEngineRerunShowDialogSelector);
  const rerunFailedShow     = useSelector(jobSearchEngineRerunFailedShowDialogSelector);
  const rerunFailedTaskShow = useSelector(jobSearchEngineRerunTaskShowDialogSelector);

  return {
    rerunFailedTaskShow,
    rerunFailedShow,
    rerunSelected,
    rerunShow
  };
};

export default useJobSearchEngineRerun;
